import { useQuery } from "@tanstack/react-query";
import { accommodationsFactory } from "@/factories/pdp/pdp-header-about-factories";

export const fetchAccommodationsData =
  (packageId: string, packageDateId: string, neoId: string, currencyId: string, marketId: string) => async (): Promise<any> => {
    try {
      const url = `/api/pdp/accommodations?packageId=${packageId}&packageDateId=${packageDateId}&neoId=${neoId}&currencyId=${currencyId}&marketId=${marketId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      const rawTourHeader = await response.json();
      return accommodationsFactory(rawTourHeader);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error sending GET request:", error); // TODO: log error to error tracking service
      throw error;
    }
  };

const useAccommodations = (
  packageId: string,
  packageDateId: string,
  neoId: string,
  currencyId: string,
  marketId: string,
  enabled: boolean = true
) =>
  useQuery<any>({
    queryKey: ["ACCOMMODATIONS", neoId, packageId, packageDateId, currencyId, marketId],
    queryFn: fetchAccommodationsData(packageId, packageDateId, neoId, currencyId, marketId),
    enabled: enabled && !!currencyId && !!marketId,
    staleTime: Infinity
  });

export default useAccommodations;
